import { useContext } from "react";

import { LicenseLeasesContext } from "./LicenseLeasesContext";

export const useLicenseLeasesContext = () => {
  const context = useContext(LicenseLeasesContext);

  if (context === undefined) {
    throw new Error("useLicenseLeasesContext must be used within a LicenseLeasesContext");
  }

  return context;
};
